import type { QueryStatus } from "@tanstack/react-query";

const combineStatuses = (...statuses: QueryStatus[]) => {
  if (statuses.length === 0) return "pending";
  if (statuses.some((status) => status === "pending")) return "pending";
  if (statuses.some((status) => status === "error")) return "error";
  if (statuses.every((status) => status === "success")) return "success";
  return "pending";
};

export default combineStatuses;
